import axios from '../axios.js'

var task = {
    // 获取我的任务工作量列表
    getTaskWorTimes: function (data, success, failure) {
        return axios.get('/resource/getTaskWorTimes', data, success, failure)
    },
    // 我的任务面板
    getMyTaskBoards: function (data, success, failure) {
        return axios.get('/taskBoard/getMyTaskBoards', data, success, failure)
    },
    // 添加/修改任务面板
    saveTaskBoard: function (data, success, failure) {
        return axios.postJson('/taskBoard/saveTaskBoard', data, success, failure)
    },
    // 获取项目面板列表
    getProjectBoards: function (data, success, failure) {
        return axios.get('/projectBoard/getProjectBoards', data, success, failure)
    },
    // 添加/修改项目面板
    saveProjectBoard: function (data, success, failure) {
        return axios.postJson('/projectBoard/saveProjectBoard', data, success, failure)
    },
    // 删除任务面板
    deleteTaskBoard2: function (data, success, failure) {
        return axios.post('/taskBoard/deleteTaskBoard', data, success, failure)
    },
    // 查看任务面板详情
    getTaskBoardInfo: function (data, success, failure) {
        return axios.get('/taskBoard/getTaskBoardInfo', data, success, failure)
    },
    // 获取泳道列表(联动)
    getTaskLaneLinks: function (data, success, failure) {
        return axios.get('/taskLane/getTaskLaneLinks', data, success, failure)
    },
    // 保存泳道
    saveTaskLane: function (data, success, failure) {
        return axios.postJson('/taskLane/saveTaskLane', data, success, failure)
    },
    // 删除泳道
    deleteTaskLane: function (data, success, failure) {
        return axios.post('/taskLane/deleteTaskLane', data, success, failure)
    },
    // 添加/修改任务面板子列表
    saveTaskBoardChildList: function (data, success, failure) {
        return axios.postJson('/taskBoardChildList/saveTaskBoardChildList', data, success, failure)
    },
    // 删除任务面板子列表
    deleteTaskBoardChild: function (data, success, failure) {
        return axios.post('/taskBoardChildList/deleteTaskBoardChild', data, success, failure)
    },
    // 添加/修改任务
    saveTask: function (data, success, failure) {
        return axios.postJson('/task/saveTask', data, success, failure)
    },
    // 移动任务到其他列表下
    move: function (data, success, failure) {
        return axios.post('/task/move', data, success, failure)
    },
    // 查看任务详情
    getTaskInfo: function (data, success, failure) {
        return axios.get('/task/getTaskInfo', data, success, failure)
    },
    // 查看任务详情
    v2getTaskInfo: function (data, success, failure) {
        return axios.get('/v2/task/getTaskInfo', data, success, failure)
    },
    // 获取任务comment列表
    getTaskComments: function (data, success, failure) {
        return axios.get('/task/getTaskComments', data, success, failure)
    },
    // 获取任务checkItem列表
    getTaskCheckItems: function (data, success, failure) {
        return axios.get('/task/getTaskCheckItems', data, success, failure)
    },
    // 更新member
    updateTaskMember: function (data, success, failure) {
        return axios.post('/task/updateTaskMember', data, success, failure)
    },
    // 修改任务信息
    updateTaskInfo: function (data, success, failure) {
        return axios.post('/task/updateTaskInfo', data, success, failure)
    },
    // 实际工作量
    setTaskRealWorkload: function (data, success, failure) {
        return axios.postJson('/task/setTaskRealWorkload', data, success, failure)
    },
    // 获取实际工作量
    getTaskRealWorkloads: function (data, success, failure) {
        return axios.get('/task/getTaskRealWorkloads', data, success, failure)
    },
    // 删除check item
    deleteTaskCheckItem: function (data, success, failure) {
        return axios.post('/task/deleteTaskCheckItem', data, success, failure)
    },
    // 添加、修改check item
    saveTaskCheckItem: function (data, success, failure) {
        return axios.postJson('/task/saveTaskCheckItem', data, success, failure)
    },
    // 修改审核状态
    changeTaskCheckItemStatus: function (data, success, failure) {
        return axios.post('/task/changeTaskCheckItemStatus', data, success, failure)
    },
    // 获取任务紧急程度列表
    getTaskFlags: function (data, success, failure) {
        return axios.get('/task/getTaskFlags', data, success, failure)
    },
    // 删除任务
    deleteTask: function (data, success, failure) {
        return axios.post('/v2/task/deleteTask', data, success, failure)
    },
    // 删除comment
    deleteTaskComment: function (data, success, failure) {
        return axios.post('/task/deleteTaskComment', data, success, failure)
    },
    // 添加comment
    addTaskComment: function (data, success, failure) {
        return axios.postJson('/task/addTaskComment', data, success, failure)
    },
    // 获取任务面板子列表
    getTaskBoardChildLists: function (data, success, failure) {
        return axios.get('/taskBoardChildList/getTaskBoardChildLists', data, success, failure)
    },
    // 复制任务到其他列表下
    copy: function (data, success, failure) {
        return axios.post('/task/copy', data, success, failure)
    },
    // 获取任务历史
    getTaskHistory: function (data, success, failure) {
        return axios.get('/task/getTaskHistory', data, success, failure)
    },
    // 添加附件
    saveTaskAttachment: function (data, success, failure) {
        return axios.postJson('/task/saveTaskAttachment', data, success, failure)
    },
    // 删除附件
    deleteTaskAttachment: function (data, success, failure) {
        return axios.post('/task/deleteTaskAttachment', data, success, failure)
    },
    // 获取任务附件列表
    getTaskAttachments: function (data, success, failure) {
        return axios.get('/task/getTaskAttachments', data, success, failure)
    },
    // 获取我的任务列表(规定条数)
    getMyTasks4Four: function (data, success, failure) {
        return axios.get('/task/getMyTasks4Four', data, success, failure)
    },

    //获取我创建的任务列表

    getMyCreateTasks: function (data, success, failure) {
        return axios.get('/task/getMyCreateTasks', data, success, failure)
    },
    // 获取我的全部任务列表
    getMyTasks: function (data, success, failure) {
        return axios.get('/task/getMyTasks', data, success, failure)
    },
    // 指定/取消指定任务执行人
    changeTaskOwner: function (data, success, failure) {
        return axios.post('/task/changeTaskOwner', data, success, failure)
    },
    // 归档/取消归档任务
    archiveTask: function (data, success, failure) {
        return axios.post('/task/archiveTask', data, success, failure)
    },
    // 完成/未完成任务
    finishTask: function (data, success, failure) {
        return axios.post('/task/finishTask', data, success, failure)
    },
    // 判断是否为当前任务的成员
    checkIsU: function (data, success, failure) {
        return axios.post('/task/checkIsU', data, success, failure)
    },

    // 根据手机号获取成员列表
    getEmployeesByMobile: function (data, success, failure) {
        return axios.get('/inviteJoin/getEmployeesByMobile', data, success, failure)
    },
    // 邀请成员
    inviteJoin: function (data, success, failure) {
        return axios.postJson('/inviteJoin/inviteJoin', data, success, failure);
    },
    // 邀请外部成员
    inviteJoinForeign: function (data, success, failure) {
        return axios.postJson('/inviteJoin/inviteJoinForeign', data, success, failure);
    },

    // 获取我被邀请的项目
    getInviteJoinProjects: function (data, success, failure) {
        return axios.get('/inviteJoin/getInviteJoinProjects', data, success, failure);
    },
    // 获取我被邀请的项目
    getInviteProjectInfos: function (data, success, failure) {
        return axios.get('/inviteJoin/getInviteProjectInfos', data, success, failure);
    },
    // 获取我被邀请的面板列表
    getInviteJoinByProject: function (data, success, failure) {
        return axios.get('/inviteJoin/getInviteJoinByProject', data, success, failure);
    },
    // 获取当前面板被邀请人列表
    getInviteJoinEmployees: function (data, success, failure) {
        return axios.get('/inviteJoin/getInviteJoinEmployees', data, success, failure);
    },
    // 删除邀请人
    deleteInviteJoin: function (data, success, failure) {
        return axios.get('/inviteJoin/deleteInviteJoin', data, success, failure);
    },
    // 月任务列表
    getMyMonthTask: function (data, success, failure) {
        return axios.get('/task/getMyMonthTask', data, success, failure);
    },
    // 周任务列表
    getMyWeekTask: function (data, success, failure) {
        return axios.get('/task/getMyWeekTask', data, success, failure);
    },
    // 日任务列表
    getMyDayTask: function (data, success, failure) {
        return axios.get('/task/getMyDayTask', data, success, failure);
    },
    //数据中心
    countMyTask: function (data, success, failure) {
        return axios.get('/task/countMyTask', data, success, failure);
    },

    /**
     * 修改任务仅创建者删除
     */
    changeTaskOnlyCreatorDelete: function (data, success, failure) {
        return axios.post('/v2/task/changeTaskOnlyCreatorDelete', data, success, failure);
    },

    /**
     * 修改任务仅创建者完成
     */
    changeTaskOnlyCreatorFinish: function (data, success, failure) {
        return axios.post('/v2/task/changeTaskOnlyCreatorFinish', data, success, failure);
    },

    /**
     * 取消任务审批
     */
    cancelTaskApprove: function(data, success, failure) {
      return axios.post('/v2/task/cancelTaskApprove',data, success, failure);
    },
}

export default task
